import React, { useState } from "react";
import { RiAppsFill } from "react-icons/ri";
import { MdLibraryAddCheck } from "react-icons/md";
import { MdAssessment } from "react-icons/md";
import { PiUserListFill } from "react-icons/pi";
import { PiKeyReturnFill } from "react-icons/pi";
import { BiSolidSpreadsheet } from "react-icons/bi";

function FloatingActionMenu({ setView }) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  const menuItems = [
    {
      icon: <MdLibraryAddCheck size={30} />,
      label: "Class Size",
      view: "class",
    },
    {
      icon: <BiSolidSpreadsheet size={30} />,
      label: "Attendance",
      view: "attendance",
    },
    {
      icon: <MdAssessment size={30} />,
      label: "Quality of Passes",
      view: "quality",
    },
    {
      icon: <PiUserListFill size={30} />,
      label: "New enrollment & Re-Enrollment",
      view: "new",
    },
    {
      icon: <PiKeyReturnFill size={30} />,
      label: "Student Evaluation",
      view: "reenrolment",
    },
  ];

  return (
    <div style={{ position: "fixed", bottom: 30, right: 30, zIndex: 1000 }}>
      <div
        style={{
          backgroundColor: "#6366F1",
          borderRadius: "30px",
          padding: isOpen ? "30px 0" : "0",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: isOpen ? 20 : 0,
          boxShadow: isOpen
            ? "inset 0 2px 6px rgba(0, 0, 0, 0.5), inset 0 -2px 4px rgba(255, 255, 255, 0.05)"
            : "none",
          maxHeight: isOpen ? 500 : 0,
          overflow: "hidden",
          opacity: isOpen ? 1 : 0,
          transition: "all 0.5s ease-in-out",
        }}
      >
        {menuItems.map((item, index) => (
          <button
            key={index}
            style={{
              background: "none",
              border: "none",
              color: "#fff",
              cursor: "pointer",
              transform: isOpen ? "translateY(0)" : "translateY(20px)",
              transition: `transform 0.3s ease ${
                index * 0.05
              }s, opacity 0.3s ease`,
              opacity: isOpen ? 1 : 0,
            }}
            title={item.label}
            onClick={() => {
              setView(item.view);
              setIsOpen(false);
            }}
          >
            {item.icon}
          </button>
        ))}
      </div>

      <button
        onClick={toggleMenu}
        style={{
          marginTop: isOpen ? 10 : 0,
          width: 60,
          height: 60,
          borderRadius: "50%",
          backgroundColor: "#6366F1",
          color: "#fff",
          border: "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow:
            "inset 0 2px 6px rgba(0, 0, 0, 0.5), inset 0 -2px 4px rgba(255, 255, 255, 0.05)",
          cursor: "pointer",
        }}
      >
        <RiAppsFill size={30} />
      </button>
    </div>
  );
}

export default FloatingActionMenu;
